module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v("O tamanho das imagens pode impactar diretamente na performance e tempo de carregamento do aplicativo.")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.save($event)
      }
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-block form form-horizontal"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4",
    class: {
      'dropdown-has-error': _vm.$v.model.id_categoria.$error
    }
  }, [_c('label', [_vm._v("Categoria*")]), _vm._v(" "), _c('select-api', {
    attrs: {
      "endpoint": '/categorias/pesquisa',
      "opt-text": 'nome',
      "select-option": true
    },
    model: {
      value: (_vm.model.id_categoria),
      callback: function($$v) {
        _vm.$set(_vm.model, "id_categoria", $$v)
      },
      expression: "model.id_categoria"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    class: {
      'dropdown-has-error': _vm.$v.model.tipo.$error
    }
  }, [_c('label', [_vm._v("Tipo*")]), _vm._v(" "), _c('Select2', {
    attrs: {
      "placeholder": "Selecione",
      "options": _vm.tipos,
      "opt-id": "id"
    },
    model: {
      value: (_vm.model.tipo),
      callback: function($$v) {
        _vm.$set(_vm.model, "tipo", $$v)
      },
      expression: "model.tipo"
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v("Selecione")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6",
    class: {
      'has-danger': _vm.$v.model.titulo.$error
    }
  }, [_c('label', [_vm._v("Titulo*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.titulo),
      expression: "model.titulo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.model.titulo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "titulo", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Autor")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.autor),
      expression: "model.autor"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.model.autor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "autor", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Data")]), _vm._v(" "), _c('input-datepicker', {
    attrs: {
      "disabled": false,
      "readonly": false,
      "group": false,
      "autoclose": true,
      "required": true
    },
    model: {
      value: (_vm.model.data),
      callback: function($$v) {
        _vm.$set(_vm.model, "data", $$v)
      },
      expression: "model.data"
    }
  })], 1), _vm._v(" "), (_vm.model.tipo === 'V') ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Url")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.url),
      expression: "model.url"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.model.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "url", $event.target.value)
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Idioma")]), _vm._v(" "), _c('Select2', {
    attrs: {
      "placeholder": "Selecione",
      "options": _vm.tiposIdioma,
      "opt-id": "idioma"
    },
    model: {
      value: (_vm.model.idioma),
      callback: function($$v) {
        _vm.$set(_vm.model, "idioma", $$v)
      },
      expression: "model.idioma"
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v("Selecione")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Conteúdo")]), _vm._v(" "), _c('vue-editor', {
    attrs: {
      "id": "editor",
      "useCustomImageHandler": ""
    },
    on: {
      "imageAdded": _vm.handleImageAdded
    },
    model: {
      value: (_vm.model.conteudo),
      callback: function($$v) {
        _vm.$set(_vm.model, "conteudo", $$v)
      },
      expression: "model.conteudo"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(1), _vm._v(" "), _c('file-image', {
    attrs: {
      "arquivo": _vm.model.arquivo
    },
    model: {
      value: (_vm.file),
      callback: function($$v) {
        _vm.file = $$v
      },
      expression: "file"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "card-footer text-right"
  }, [_c('router-link', {
    staticClass: "btn btn-link",
    attrs: {
      "to": {
        name: 'list-post'
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Salvar")])], 1)]), _vm._v(" "), (_vm.model.id) ? _c('dw-select-add', {
    attrs: {
      "url-select": 'post/pesquisa',
      "opt-text": 'titulo',
      "title": 'Posts Relacionados',
      "model-name": 'post-relacionado',
      "model-id": _vm.model.id,
      "param-name": 'post',
      "param-label": 'titulo',
      "object-list": 'relacionados',
      "draggable": false
    }
  }) : _vm._e()], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-menu"
  }), _vm._v(" Post\n                    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-warning"
  }, [_c('strong', [_vm._v("Atenção!")]), _vm._v("\n                                    O tamanho máximo e indicado para a\n                                    "), _c('strong', [_vm._v("Imagem")]), _vm._v(" é de\n                                    "), _c('strong', [_vm._v("500kb")]), _vm._v(".\n                                ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2315ab36","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/post/Form.vue
// module id = 839
// module chunks = 1